// Razorpay configuration and payment utilities
import { razorpayApi } from './api';

// Razorpay configuration

//const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_RQEaTKDGCleh2j'; // Replace with your test key
const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_live_RQccDFgQTj9Tj8'; // Replace with your test key

// Cache for subscription plans
let plansCache = null;
let plansCacheTime = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// Fetch subscription plans from API
export const fetchSubscriptionPlans = async () => {
  try {
    // Check cache first
    const now = Date.now();
    if (plansCache && (now - plansCacheTime) < CACHE_DURATION) {
      return plansCache;
    }

    const response = await fetch(`${process.env.REACT_APP_API_BASE}/razorpay/subscription-plans`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken') || localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch subscription plans');
    }

    const result = await response.json();
    plansCache = result.plans || [];
    plansCacheTime = now;
    
    return plansCache;
  } catch (error) {
    console.error('Error fetching subscription plans:', error);
    // Return fallback plans if API fails
    return [
      {
        id: 'trial',
        name: 'Trial',
        description: 'Free trial with limited features - no expiry',
        price: 0,
        currency: 'INR',
        interval: 'month',
        intervalCount: 1,
        duration: 0, // 0 means no expiry
        features: ['Orders limit: 100 total', 'Expenses limit: 100 total', 'Access to business overview', 'No expiry - use until limits reached']
      },
      {
        id: 'pro',
        name: 'Pro',
        description: 'Everything unlimited',
        price: 2000,
        currency: 'INR',
        interval: 'year',
        intervalCount: 1,
        duration: 365,
        monthlyPrice: 167,
        features: ['Unlimited orders', 'Unlimited expenses', 'Advanced analytics', 'Priority support']
      },
      {
        id: 'pro3year',
        name: 'Pro 3-Year',
        description: 'Best value for long-term growth',
        price: 4000,
        currency: 'INR',
        interval: 'year',
        intervalCount: 3,
        duration: 1095,
        monthlyPrice: 111,
        features: ['Everything in Pro', '3 years of service', 'Save ₹2,000 vs annual', 'Priority support']
      }
    ];
  }
};

// Create Razorpay order
export const createRazorpayOrder = async (planId, userId, userEmail) => {
  try {
    const plans = await fetchSubscriptionPlans();
    const plan = plans.find(p => p.id === planId);
    if (!plan) {
      throw new Error('Invalid plan selected');
    }

    // Call backend API to create order
    const result = await razorpayApi.createOrder(planId, userId, userEmail);
    return result.order;
  } catch (error) {
    console.error('Error creating Razorpay order:', error);
    throw error;
  }
};

// Open Razorpay payment modal
export const openRazorpayPayment = async (order, planId, onSuccess, onError) => {
  const plans = await fetchSubscriptionPlans();
  const plan = plans.find(p => p.id === planId);
  
  const options = {
    key: RAZORPAY_KEY_ID,
    amount: order.amount,
    currency: order.currency,
    name: 'TrackProfit',
    description: `${plan.name} Subscription`,
    order_id: order.id,
    prefill: {
      email: order.notes.userEmail,
    },
    theme: {
      color: '#10B981' // Green theme matching your app
    },
    handler: function (response) {
      // Payment successful
      onSuccess(response, order);
    },
    modal: {
      ondismiss: function() {
        // Payment cancelled
        onError('Payment cancelled by user');
      }
    }
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};

// Verify payment on frontend (basic verification)
export const verifyPayment = async (paymentResponse, orderId) => {
  try {
    const result = await razorpayApi.verifyPayment({
      razorpay_payment_id: paymentResponse.razorpay_payment_id,
      razorpay_order_id: paymentResponse.razorpay_order_id,
      razorpay_signature: paymentResponse.razorpay_signature,
      order_id: orderId
    });
    return result;
  } catch (error) {
    console.error('Error verifying payment:', error);
    throw error;
  }
};

